import React from 'react';
import classnames from 'classnames';
import type Tool from '../../tools/Tool';

export function svgToIcon(
  svgFile: any,
  options: { className?: string } = {}
): JSX.Element {
  // We use this pattern of putting the SVG as inner HTML so that the color
  // of the SVG is controlled by the font color.

  return (
    <i
      className={classnames(`fa-regular`, options.className)}
      style={{ lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svgFile }}
    />
  );
}

// Shared helper for rendering tool icons with consistent logic across toolbar, menus, and command menu
export function renderToolIcon(
  tool: typeof Tool,
  additionalClasses?: string
): JSX.Element {
  const className = additionalClasses
    ? classnames(additionalClasses, tool.iconClass)
    : tool.iconClass;

  if (tool.iconSvg) {
    return svgToIcon(tool.iconSvg);
  } else if (tool.iconElement) {
    return React.createElement(
      tool.iconElement,
      {
        className,
      },
      null
    );
  } else {
    return <i className={className} />;
  }
}
